import axios from 'axios'

const request = axios.create({
  // 测试环境
  // baseURL: 'http://test-9game.laolongtang.com.cn'

  // 生产环境
  baseURL: 'https://manage.hawaiiglobalholiday.com'
})
export default request
